import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpUrlGenerator } from "@ngrx/data";
import { ApiResponse, RestService } from "@recore-solutions/nstar-lib";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { NstarDataService } from "src/app/nstar-data.service";
import { environment } from "src/environments/environment";
import { ListingMedia } from "../shared/interfaces/listing-media";

@Injectable({
	providedIn: "root",
})
export class ListingMediaDataService extends NstarDataService<ListingMedia> {
	constructor(
		protected httpClient: HttpClient,
		protected httpUrlGenerator: HttpUrlGenerator,
		protected restService: RestService
	) {
		super("ListingMedia" as never, httpClient, httpUrlGenerator);
	}

	getListingMediaApiResponse(queryParams?: Record<string, any>): Observable<ListingMedia[]> {
		queryParams = {
			...queryParams,
			Delete_DTTM: "ISNULL",
		};
		const params = this.queryParamsToHttpParams(queryParams);
		return this.restService
			.get<ApiResponse<ListingMedia>>(environment.endpoints.media, params)
			.pipe(
				map((response) => response?.records || []),
				catchError(() => of([]))
			);
	}

	getAll(): Observable<ListingMedia[]> {
		return this.getListingMediaApiResponse();
	}

	getWithQuery(params: Record<string, any>): Observable<ListingMedia[]> {
		return this.getListingMediaApiResponse(params);
	}
}
